import { Rate } from 'antd';
import { Col } from 'components/Box/Col';
import { Row } from 'components/Box/Row';
import Button from 'components/Button';
import Text from 'components/Text';
import { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import ShopInfo from 'widgets/ShopInfo';
import FeedbackReasonModal, { FeedbackReasonModalRef } from './components/FeedbackReasonModal';
import { IResponseDataBody } from 'services/response';
import shopApis from 'services/shop/apis';

const FeedbackPage = () => {
  const { shop_id, billId } = useParams<{ shop_id: string; billId: string }>();
  const [rating, setRating] = useState(0);
  const useFeedbackReasonModal = useRef<FeedbackReasonModalRef>(null);
  const navigate = useNavigate();
  const onNext = async () => {
    if (rating <= 4) {
      useFeedbackReasonModal.current?.open(rating);
    } else {
      const res: IResponseDataBody = await shopApis.feedbackReview({
        billId: billId || '',
        stars: rating,
      });

      if (res?.data?.data) {
        navigate(`/store/${shop_id}/review/${res.data.data}`);
      }
    }
  };

  return (
    <Wrapper>
      <Container>
        <ShopInfo />
        <Content>
          <Col justifyContent='center' alignItems='center' gap='1'>
            <Text variant='H3' textAlign='center'>
              How was your experience?
            </Text>
            <Text variant='CONTENT_1' color='text_4' textAlign='center' weight='medium'>
              Tap a star to rate
            </Text>
          </Col>
          <Col justifyContent='center' alignItems='center' gap='1'>
            <Rate className='feedback-rate' value={rating} onChange={setRating} />
            <Row width='100%' justifyContent='space-between'>
              <Text variant='BODY_1' color='text_3_v2' weight='medium'>
                Very poor
              </Text>
              <Text variant='BODY_1' color='text_3_v2' weight='medium'>
                Excellent
              </Text>
            </Row>
          </Col>
        </Content>
        <Action>
          <Button ntype='TERTIARY' onClick={onNext} style={{ width: '100%' }} size='middle' disabled={rating === 0}>
            Next
          </Button>
        </Action>
      </Container>
      <FeedbackReasonModal ref={useFeedbackReasonModal} onClearRating={() => setRating(0)} />
    </Wrapper>
  );
};

export default FeedbackPage;

const Wrapper = styled.div`
  height: 100vh;
  background: #232f3e;
  display: flex;
  justify-content: center;
  font-family: Mona Sans;
`;

const Container = styled.div`
  background: #fff;
  height: 100%;
  max-width: 476px;
  display: flex;
  flex-direction: column;
  position: relative;
  font-family: Mona Sans;

  .divider {
    background: #ddd;
    height: 1px;
    width: 100%;
    margin-bottom: 1rem;
  }

  @media only screen and (max-width: 500px) {
    width: 100%;
    max-width: unset;
  }
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 16px 16px 32px;

  .feedback-rate {
    font-size: 64px;
    line-height: 1;

    @media (max-width: 400px) {
      font-size: 50px;
    }
  }
`;

const Action = styled.div`
  width: 100%;
  display: flex;
  padding: 12px 16px 24px;
  position: sticky;
  bottom: 0;
  box-sizing: border-box;
  .CONTENT_2 {
    font-size: 20px;
    font-family: Mona Sans;
  }
`;
